<template>
	<div class="fun_box">
		<div class="contentBox" style="padding-top: 20px;">
			<h2>功能查询</h2>
			<div class="fun_list">
				<div class="fun_one fun" @click="tofinish">
					<img src="../../../static/images/com_images/icon_07.png" alt="">
					<span>已完成案件查询</span>
				</div>
				<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toadd()">保险公司合同管理</span>
				</div>
				<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toRegulators()">新增保险合作客户</span>
				</div>
				<div class="fun_one fun">
					<img src="../../../static/images/com_images/icon_08.png" alt="">
					<span @click="toserve()">设置服务流程</span>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:
					this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data
			};
		},		
		methods: {
			tofinish() {
				this.$router.push({
					name: "finishEnd",
					params: {
						token: this.token
					}
				});
			},
			toadd() {
				this.$router.push({
					name: "pact",
					params: {
						token: this.token,
					},
				});
			},
			/** 进入新增保险合作客户 */
			toRegulators() {
				this.$router.push({
					name: "add",
					params: {
						token: this.token,
					},
				});
			},
			toserve() {
				this.$router.push({
					name: "serve",
					params: {
						token: this.token,
					},
				});
			}
		}
	};
</script>

<style scoped>
	.fun_box {
		background-color: white;
		padding: 0 0 50px 0;
	}

	.contentBox {
		width: 1200px;
		margin: 0 auto;
	}

	h2 {
		font-size: 20px;
		color: #333;
	}

	.fun_one {
		margin-top: 20px;
		cursor: pointer;
	}

	.fun_one img {
		vertical-align: middle;
	}

	.fun_one span {
		vertical-align: middle;
		font-size: 18px;
		padding-left: 10px;
		color: #666;
	}

	.warnBox {
		overflow: hidden;
		padding: 50px 0;
	}

	.warnBox img {
		float: left;
	}

	.warnBox .overflow {
		float: left;
		margin-left: 20px;
	}

	.warnBox .overflow h3 {
		font-size: 18px;
		font-weight: normal;
	}

	.warnBox .overflow p {
		font-size: 14px;
		line-height: 30px;
		color: #666;
	}

	.warnBox .text {
		float: right;
		color: #666;
	}

	.fun_list {
		overflow: hidden;
	}

	.fun_list .fun_one {
		float: left;
		margin-left: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/footer.vue